"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

import { Post } from "@/shared/libs/axios/request";
import { stockKeys } from "@/entities/stock";
import { itemKeys } from "@/entities/item";
import type {
  CreateStockInRequest,
  StockInResultResponse,
} from "@stocks/shared";

/** 입고 확정 (로트/보관 위치 신규 등록 포함). 성공 시 재고·로트·위치 목록을 갱신한다. */
export const useCreateStockIn = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (values: CreateStockInRequest) =>
      Post<StockInResultResponse, CreateStockInRequest>(
        "/v1/stocks/in",
        values,
      ),
    onSuccess: (res) => {
      qc.invalidateQueries({ queryKey: [stockKeys.stocks] });
      qc.invalidateQueries({ queryKey: [stockKeys.lots] });
      qc.invalidateQueries({ queryKey: [stockKeys.locations] });
      qc.invalidateQueries({ queryKey: itemKeys.all });
      toast.success(res.data.message);
    },
    onError: (error) =>
      toast.error(error.response?.data.message ?? "입고 확정에 실패했습니다."),
  });
};
